import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackPurchaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackPurchase";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackPurchase = (
    parameters: PartialSpecific<TrackPurchaseParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackPurchaseParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        promotions: ga.use.promotions(options),
        cart: ga.use.cart(options, true),
        ...options,
    };

    return (parameters: Partial<TrackPurchaseParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.purchase({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};
export default useTrackPurchase;
